<template>
  <div
    class="Index flex-direction-column justify-center"
    ref=wrappers
    @mousewheel=mousewheel
    @touchstart=touchstart
    @touchmove=touchmove
    @touchend=touchend
  >
    <div class="wrapper page1 d-flex" :class="{prev: page > 0}">
      <iframe
        style="margin: auto; max-height: 60vh;"
        width="1080"
        height="600"
        src="https://www.youtube.com/embed/VHaJhFJlCv8"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <div class=scrollDown @click="next">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="wrapper page2 justify-align-center flex-direction-column" :class="{prev: page > 1, next: page < 1}">
      <div class="content d-flex">
        <div class="image d-flex align-center">
          <img src="/static/img/myoungdayTop.png" alt="" @click="hiddenpiece">
        </div>
        <div class="letter" @touchmove.stop @mousewheel.stop>
          <p>안녕하세요 <b>트위치 스트리머 명데</b>입니다!</p>
          <p>방송 1주년 기념 으로 10월 2일날 진행하려던 컨텐츠가<br>방송 사고로 인해 <b>11월 7일</b>로 다시 연기 되었습니다.</p>
          <p>진행이 연기 되는 것 만큼, 더욱더 꼼꼼하고 재미있는 컨텐츠로 보답해드리겠습니다.</p>
          <p>컨텐츠 진행에 앞서 해당 컨텐츠가 어떠한 종류를 담고 있는지, 또 이러한 컨텐츠를 진행하게 된 계기과 이를 통해 얻고자 하는 것이 무엇인지 설명해 드리고자 공지와 함께 글을 올립니다.</p>
          <p><b>&lt;굶지마! 철인 3종 경기&gt;</b> 는 Don't Starve Together 의 본질을 해치지 않고, 여러 가지 변수와 모험을 해 나가는 투게더 유저들에게 조금 더 신선한 재미와, 본 게임의 창의력에 선한 영향력을 일으키고자 이 컨텐츠를 제작 하게 되었습니다.</p>
          <p>저 또한 투게더를 즐기고 사랑하는 유저인 만큼, 치트, 콘솔을 사용 하지 않고싶었고, 오로지 게임을 있는 그대로 즐기며, 이 또한 투게더 유저들에게 신선한 창의력을 가져다 줄 수 있겠다, 라는 생각이 들어, 방송 1주년을 기념하여, 여러분들에게 제가 꿈에만 그리고 있던 컨텐츠들을 한 번에 모아 보여드리고 싶었습니다.</p>
          <p>앞서 말 한 듯이 제작 과정도 물론이며, 그것을 시행하기 위해 필요한 아이템 수급과 공급을 모두 no콘솔, no치트로 진행해, 저와 함께 수고해 주신 스텝분들, 트수분들에게 항상 감사할 따름이고, 이 컨텐츠를 진행 하면서 모두가 강한 기대와 인상으로 남아, 행복한 추억이 되었으면 좋겠다는 생각입니다.</p>
        </div>
      </div>
      <div class="link d-flex">
        <a href="mailto:imeden1104@naver.com">
          <img src="/static/img/naver_mail.ico"> 비즈니스 이메일
        </a>
        <a href="https://discord.com/channels/759832594174181417/759832594174181421" target="_blank">
          <img src="/static/img/discord.ico"> 명태마을 디스코드
        </a>
        <a href="https://www.twitch.tv/myoungday" target="_blank">
          <img src="/static/img/twitch.png"> 트위치
        </a>
      </div>
    </div>
    <div class="wrapper page3 justify-align-center" :class="{prev: page > 2, next: page < 2}">
      <div class="card d-flex">
        <div class="label p-2" style="">
          <div>기본</div>
          <div>규칙</div>
          <div class="en">Rule</div>
        </div>
        <div class="content flex-direction-column justify-align-center p-2 text-left">
          <ol>
            <li>
              <div>게임 진행에 필요한 기본적인 도구와 음식은 <strong>스스로</strong> 구합니다</div>
              <div><small>(경기 시작 전, 기본적인 음식과 무기 제공)</small></div>
            </li>
            <li>제한구역을 제외한 모든 곳에서 <strong>자원</strong>을 구할 수 있습니다</li>
            <li>게임 종류는 <strong>메인 경기</strong> 3개, <strong>캐릭터 미니게임</strong> 5개, <strong>특별게임</strong> 1개로 총 9개 입니다</li>
            <li>
              <div>게임을 진행하는 모든 캐릭터는 6명 전부 <strong>동일한 캐릭터</strong>로 진행합니다</div>
              <div><small><strong>메인 게임</strong>은 룰렛으로 진행할 캐릭터를 고릅니다</small></div>
              <div><small><strong>캐릭터 미니게임</strong>과 <strong>특별게임</strong>은 미션에 맞는 캐릭터를 사용합니다</small></div>
            </li>
          </ol>
        </div>
      </div>
    </div>
    <div class="wrapper page4 justify-align-center" :class="{prev: page > 3, next: page < 3}">
      <div class="card d-flex">
        <div class="label p-2" style="">
          <div>설정</div>
          <div class="en">Config</div>
        </div>
        <div class="content flex-direction-column justify-align-center p-2 text-left">
          <ol>
            <li>계절은 봄/가을로만 진행하며 여름/겨울은 <strong>없습니다</strong></li>
            <li>
              <div>시간은 밤 없이 진행하며 하루 8분 기준으로 한 게임 당 3일 (24분) 동안 진행합니다</div>
              <div><small>플레이 시간: <strong>약 3시간 30분</strong></small></div>
            </li>
            <li>경기를 플레이 하는 동안 지하(뚫려 있는 모든 지하 포탈)는 이용 하실 수 없습니다</li>
            <li>계절거인(구스무스, 곰소리, 외눈사슴)과 랜덤으로 출현하는 몬스터(하운드, 크람푸스) 등은 출연하지 않습니다</li>
          </ol>
        </div>
      </div>
    </div>
    <div class="wrapper page5 justify-align-center" :class="{prev: page > 4, next: page < 4}">
      <div class="card d-flex">
        <div class="label p-2">
          <div>지도</div>
          <div class="en">Map</div>
        </div>
        <div class="content flex-direction-column">
          <div class="maps flex-direction-column justify-align-center p-2">
            <img v-show="map === 'base'" src="/static/img/map/base.png" alt="기본" @click="openMap('/static/img/map/base.png')">
            <img v-show="map === 'redzone'" src="/static/img/map/redzone.png" alt="제한구역" @click="openMap('/static/img/map/redzone.png')">
            <img v-show="map === 'beefalo'" src="/static/img/map/beefalo.png" alt="비팔로 경주" @click="openMap('/static/img/map/beefalo.png')">
            <img v-show="map === 'wx-78'" src="/static/img/map/wx-78.png" alt="wx-78" @click="openMap('/static/img/map/wx-78.png')">
            <img v-show="map === 'warly'" src="/static/img/map/warly.png" alt="왈리" @click="openMap('/static/img/map/warly.png')">
            <img v-show="map === 'boat'" src="/static/img/map/boat.png" alt="보트 경주" @click="openMap('/static/img/map/boat.png')">
            <img v-show="map === 'lucy'" src="/static/img/map/woodie.png" alt="우디" @click="openMap('/static/img/map/woodie.png')">
            <img v-show="map === 'webber'" src="/static/img/map/webber.png" alt="웨버" @click="openMap('/static/img/map/webber.png')">
            <img v-show="map === 'pvp'" src="/static/img/map/pvp.png" alt="pvp" @click="openMap('/static/img/map/pvp.png')">
            <img v-show="map === 'woodie'" src="/static/img/map/special.png" alt="특별게임" @click="openMap('/static/img/map/special.png')">
            <img v-show="map === 'willow'" src="/static/img/map/willow.png" alt="윌로우" @click="openMap('/static/img/map/willow.png')">
            <img v-show="map === 'ending'" src="/static/img/map/ending.png" alt="엔딩" @click="openMap('/static/img/map/ending.png')">
          </div>
          <div class="flex-direction-row justify-center">
            <button @click="map = 'base'">기본</button>
            <button @click="map = 'redzone'">제한구역</button>
            <button @click="map = 'beefalo'">비팔로 경주</button>
            <button @click="map = 'wx-78'">WX-78</button>
            <button @click="map = 'warly'">왈리</button>
            <button @click="map = 'boat'">보트 경주</button>
            <button @click="map = 'lucy'">우디</button>
            <button @click="map = 'webber'">웨버</button>
            <button @click="map = 'pvp'">PVP</button>
            <button @click="map = 'woodie'">특별게임</button>
            <button @click="map = 'willow'">윌로우</button>
            <button @click="map = 'ending'">포토존</button>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper page6 justify-align-center" :class="{prev: page > 5, next: page < 5}">
      <div class="card d-flex">
        <div class="label p-2">
          <div>모드</div>
          <div class="en">Mods</div>
        </div>
        <div class="content flex-direction-column justify-align-center p-2">
          <p><strong><a href="https://steamcommunity.com/sharedfiles/filedetails/?id=1781410139">zoom+</a></strong> 만 사용 가능</p>
          <p>(글로벌 포지션, 쇼미, 미니맵 등 편의성 모드는 사용 불가)</p>
        </div>
      </div>
    </div>
    <div class="wrapper page7 justify-align-center" :class="{prev: page > 6, next: page < 6}">
      <div class="card d-flex">
        <div class="label p-2">
          <div>이용</div>
          <div>불가</div>
          <div>캐릭터</div>
          <div class="en">Ban</div>
        </div>
        <div class="content flex-direction-column justify-align-center p-2">
          <div class="characters">
            <img :src="'/static/img/Wolfgang_Portrait.png'">
            <img :src="'/static/img/Wigfrid_Portrait.png'">
            <img :src="'/static/img/Waxwell_Portrait.png'">
            <img :src="'/static/img/Wortox_Portrait.png'">
            <img :src="'/static/img/Wormwood_Portrait.png'">
            <img :src="'/static/img/Wurt_Portrait.png'">
            <img :src="'/static/img/Wanda_Portrait.png'">
          </div>
          <p>pvp에 특화된 캐릭터와<br>유료 캐릭터는 이용할 수 없습니다</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    pass: 0,
    timer: null,
    page: 0,
    busy: false,
    touch: {
      touched: false,
      y: null
    },
    map: 'base'
  }),
  methods: {
    hiddenpiece () {
      this.pass++

      if (this.pass === 10) {
        this.pass = 0
        this.$emit('auth')
      }

      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.pass = 0
      }, 1000)
    },
    openMap (url) {
      window.open(url, 'map')
    },
    mousewheel (e) {
      if (e.deltaY < 0) this.prev()
      if (e.deltaY > 0) this.next()
    },
    touchstart (e) {
      this.touch.y = e.touches[0].clientY
      this.touch.touched = true
    },
    touchmove (e) {
      if (!this.touch.touched) return
      const y = e.touches[0].clientY

      if (y < this.touch.y - 20) {
        this.next()
        this.touchend()
      } else if (y > this.touch.y + 20) {
        this.prev()
        this.touchend()
      }
    },
    touchend () {
      this.touch.touched = false
      this.touch.y = null
    },
    prev () {
      if (this.busy || this.page < 1) return
      this.busy = true
      this.page = this.page - 0.5
      setTimeout(() => {
        this.page = this.page - 0.5
        this.busy = false
      }, 100)
    },
    next () {
      if (this.busy || this.page >= this.$refs.wrappers.children.length - 1) return
      this.busy = true
      this.page = this.page + 0.5
      setTimeout(() => {
        this.page = this.page + 0.5
        this.busy = false
      }, 100)
    }
  }
}
</script>

<style scoped>
.Index {
  position: relative;
  height: 100%;
  background-image: url('/static/img/myoungday.png');
  background-size: cover;
  background-position: 80% center;
  background-color: #fffa;
  background-blend-mode: screen;
  background-attachment: fixed;
  overflow: hidden;
}
.wrapper {
  position: absolute;
  margin: 0 auto;
  padding: 0 1em;
  max-width: 1080px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  word-break: keep-all;
  transition: all .5s ease-in-out;
}
.wrapper.prev {
  transform: translateY(-100%);
}
.wrapper.next {
  transform: translateY(100%);
}
.image, .letter {
  flex: 1;
  width: 50%;
  height: 60vh;
  max-height: 440px;
}
.letter {
  padding: 1rem;
  background: #fff9;
  font-size: 14px;
  overflow-y: auto;
}
.page2 .image img {
  width: 100%;
}
.link {
  margin: 1em auto;
  padding: 1rem;
  max-width: 360px;
  background: white;
  color: #999;
  font-size: 12px;  
  gap: 1em;
}
.link>a:hover {
  color: #000;
}
.link img {
  width: 20px;
  height: 20px;
  vertical-align: -5px;
}
.scrollDown {
  position: absolute;
  bottom: 100px;
  left: 0;
  right: 0;
}
.scrollDown span {
  display: inline-block;
  position: absolute;
  width: 40px;
  height: 40px;
  transform: translate(-50%) rotate(45deg);
  border-right: solid 2px #fff;
  border-bottom: solid 2px #fff;
  box-shadow: 1px 1px 1px #555;
  animation: blink 1.5s infinite ease-in-out;
}
.scrollDown span:nth-child(1) {
  top: -15px;
  animation-delay: -0.2s;
}
.scrollDown span:nth-child(2) {
  top: 0;
  animation-delay: 0s;
}
.scrollDown span:nth-child(3) {
  top: 15px;
  animation-delay: 0.2s;
}
@keyframes blink {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50%, 100% {
    opacity: 0;
  }
}
.page5 .maps img {
  width: 80vw;
  max-width: 600px;
  cursor: pointer;
}
.page5 .content {
  display: flex;
}
.page7 .characters img {
  width: 50px;
}
.card {
  max-width: 800px;
}
.card .label {
  color: white;
  font-size: 30px;
  font-weight: 800;
  text-align: right;
  background: #222;
}
.card .label .en {
  font-size: 20px;
}
.card .content {
  background: #fff9;
}
@media screen and (max-width: 1080px) {
.page2 .image {
  width: auto;
}
.page2 .image img {
  width: 190px;
}
.page2 .content {
  flex-direction: column;
}
.page2 .content>div {
  margin: 0 auto;
}
.page2 .content .letter {
  width: 80%;
  max-height: calc(100vh - 370px);
}
.card {
  flex-direction: column;
}
.card .label {
  display: flex;
  font-size: 20px;
  align-items: flex-end;
  gap: .4em;
}
.card .label .en {
  font-size: 16px;
}
.card .content {
  font-size: 12px;
}
.page5 .content {
  flex-direction: column;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue